var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"address-info"},[(_vm.isTablet)?_c('h5',{staticClass:"font-weight-regular fs-10 text-gray"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"fs-12 fs-md-14 d-flex pr-md-4",domProps:{"innerHTML":_vm._s(_vm.addressInfo)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }